export const CHECK_STATUS = {
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
  SUBMITTED: "SUBMITTED",
};
